<template>
  <group-select :valores="eixosTotais"></group-select>
</template>

<script>
import { axisAPI } from "@/modules/axis";
import groupSelect from "../../../components/groupSelect/groupSelect.vue";
import { eixosGrupoAPI } from "@/modules/eixosGrupo/API/eixosGrupoApi";

export default {
  name: "AppAxisByProjectCombobox",
  props: ["filter"],
  components: { groupSelect },
  mounted() {
    this.loadGroupEixos();
  },
  methods: {
    loadEixos() {
      axisAPI
        .list()
        .then((resp) => {
          this.Eixos = resp.data;
          console.log("this.EixosGroupo: ", this.EixosGroupo);

          this.EixosGroupos.forEach((item) => {
            this.eixosTotais.push({
              name: item.nome,
              value: "group",
              sons: JSON.parse(item.eixoIds),
            });
            this.Eixos.forEach((val) => {
              if (JSON.parse(item.eixoIds).some((ei) => ei === val.eixoId)) {
                this.eixosTotais.push({ name: val.nome, value: val.eixoId });
              }
            });
          });
          console.log("this.eixosTotais: ", this.eixosTotais);
        })
        .catch();
    },
    loadGroupEixos() {
      eixosGrupoAPI
        .get()
        .then((resp) => {
          this.EixosGroupos = resp.data;
          this.loadEixos();
        })
        .catch();
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.eixo = [];
        } else {
          this.filter.eixo = this.Eixos.slice();
        }
      });
    },
  },
  computed: {
    likesAll() {
      return this.filter.eixo.length === this.Eixos.length;
    },
    likesSome() {
      return this.filter.eixo.length > 0 && !this.Eixos;
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  data() {
    return {
      maxDisplay: 2,
      Eixos: [],
      EixosGroupos: [],
      eixosTotais: [],
    };
  },
};
</script>
